import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/hooks/useAuth';
import LanguageSwitch from './LanguageSwitch';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const NAV_ITEMS = [
  { to: '/dashboard', key: 'dashboard' as const },
  { to: '/tasks', key: 'tasks' as const },
  { to: '/phone-config', key: 'phoneConfig' as const },
  { to: '/settings', key: 'settings' as const },
  { to: '/help', key: 'help' as const },
];

export default function Sidebar() {
  const { t } = useTranslation('common');
  const { user, logout } = useAuth();

  return (
    <aside className="flex h-screen w-[200px] shrink-0 flex-col border-r bg-card">
      <div className="border-b px-4 py-3 text-lg font-semibold tracking-tight">
        {t('app.name')}
      </div>
      <nav className="flex-1 space-y-1 p-2 text-sm">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.key}
            to={item.to}
            className={({ isActive }) =>
              cn(
                'block rounded-md px-3 py-2 transition-colors',
                isActive
                  ? 'border-l-2 border-primary bg-accent font-medium text-accent-foreground'
                  : 'text-muted-foreground hover:bg-accent/50 hover:text-foreground',
              )
            }
          >
            {t(`nav.${item.key}`)}
          </NavLink>
        ))}
      </nav>
      <div className="space-y-2 border-t p-3 text-xs">
        <div className="truncate text-muted-foreground">{user?.username}</div>
        <LanguageSwitch className="w-full justify-stretch" />
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="w-full justify-start"
          onClick={() => void logout()}
        >
          {t('actions.logout')}
        </Button>
      </div>
    </aside>
  );
}
